import './DownloadPay2Nomile.css';
import playstor from '../../assets/images/playstor.svg';
import applestor from '../../assets/images/apple.svg';
import img from '../../assets/images/cre-32.png';

function Component() {
	return (
		<>
			<div className="DownloadPayWrapper">
				<div className="container">
					<div className=" flex download-wrapper justify-center gap-50">
						<div className="left">
							<h2 className="heading-2 fs-sm-20">
								One app for <span className="strong">everything</span>
							</h2>
							<p className='fs-sm-12'> download Pay2Mobile, and enjoy all the Pay2Mobile services in just one super app.</p>

							<div>
								<p>Download Pay2Mobile</p>
								<div className="app flex gap-20">
								<a href="https://play.google.com/store/apps/details?id=com.webetechies.b2c" target='_blank'> <img src={playstor} alt="playstor" /></a>
								</div>
							</div>
						</div>
						<div className="right">
							<img src={img} alt="mobile" />
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default Component;
